import React, { useState, useEffect } from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import LeftPanel from "./include/LeftPanel";
import Global from "../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from '../components/ui/toast';
import AuthUser from "../AuthUser";
import { useNavigate, useParams } from 'react-router-dom';
import MainLoader from "./Loaders/MainLoader";
import { ArrowLeft, Warehouse, Loader2 } from 'lucide-react';


function WarehouseEdit() {
    let navigate = useNavigate();
    let { uniqueid } = useParams();
    const { headers1, headers2, logout } = AuthUser();
    const [Name, setName] = useState('');
    const [Phone, setPhone] = useState('');
    const [Zip, setZip] = useState('');
    const [Country, setCountry] = useState('');
    const [City, setCity] = useState('');
    const [Address, setAddress] = useState('');
    const [Countrylist, setCountrylist] = useState([]);
    const [Citylist, setCitylist] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);

    useEffect(() => {
        GetCustomerDetail();
        GetCountrylist();
    }, []);
    const items = JSON.parse(localStorage.getItem('user'));
    const GetCustomerDetail = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'WarehouseEdit',
            headers: headers2,
            data: {
                warehouseid: uniqueid,
                cust_id: items.uniqueid
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setName(data.warehouseName);
                    setPhone(data.phone);
                    setZip(data.pincode);
                    setCountry(data.country);
                    setCity(data.city);
                    setAddress(data.address);
                    handleCountryChange(data.country);
                    handleCityChange(data.city);
                    setLoading(false);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setLoading(false);
            });
    }
    const GetCountrylist = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Countrylist',
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setCountrylist(data);
                }
            })
            .catch(function (error) {
            });
    }
    const GetCityList = (val) => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Citylist',
            data: {
                name: val
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setCitylist(data);
                }
            })
            .catch(function (error) {
            });
    }
    const handleCountryChange = (val) => {
        setCountry(val);
        GetCityList(val);
    };
    const handleCityChange = (val) => {
        setCity(val);
    };

    const handleSubmit = () => {
        if (Name == "") {
            toast.warning('Customer Name is Required');
        }
        else if (Phone == "") {
            toast.warning('Customer Phone NO. is Required');
        }
        else if (Zip == "") {
            toast.warning('Postal Code is Required');
        }
        else if (Country == "") {
            toast.warning('Please Select Country');
        }
        else if (City == "") {
            toast.warning('Please Select City');
        }
        else if (Address == "") {
            toast.warning('Address is Required');
        }
        else {
            setSubloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl + 'WarehouseEditsubmit',
                headers: headers2,
                data: {
                    warehouseid: uniqueid,
                    warehouseName: Name,
                    phone: Phone,
                    pincode: Zip,
                    country: Country,
                    city: City,
                    address: Address,
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        setSubloading(false);
                        toast.success(response.data.message);
                        setTimeout(() => {
                            navigate('/WarehouseList');
                        }, 1000);
                    } else {
                        setSubloading(false);
                        toast.warning(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                    setSubloading(false);
                });
        }
    }

    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                {Loading == true ? <MainLoader /> :
                    <div className="px-content">
                        <div className="px-pagehead">
                            <div className="px-pagehead__left">
                                <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                                    <ArrowLeft size={16} />
                                </button>
                                <h2 className="px-pagehead__title">Update Warehouse</h2>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <div className="px-card">
                                    <div className="px-card__head">
                                        <span className="px-card__title"><Warehouse size={16} />Warehouse details</span>
                                    </div>
                                    <div className="px-card__body">
                                        <div className="px-auth-grid">
                                            <div className="px-form-group">
                                                <label>Name <span className="px-req">*</span></label>
                                                <input type="text" disabled className="px-input" value={Name} onChange={(e) => setName(e.target.value)} placeholder="Customer name" />
                                            </div>
                                            <div className="px-form-group">
                                                <label>Phone <span className="px-req">*</span></label>
                                                <input type="number" className="px-input" value={Phone} onChange={(e) => setPhone(e.target.value)} placeholder="Customer phone no." />
                                            </div>
                                            <div className="px-form-group">
                                                <label>Postal Code <span className="px-req">*</span></label>
                                                <input type="text" className="px-input" value={Zip} onChange={(e) => setZip(e.target.value)} placeholder="Customer postal code" />
                                            </div>
                                            <div className="px-form-group">
                                                <label>Country <span className="px-req">*</span></label>
                                                <select className="px-select" value={Country} onChange={(e) => handleCountryChange(e.target.value)}>
                                                    <option value="">-- Please Select --</option>
                                                    {Countrylist.map((list, i) => {
                                                        return (
                                                            <option key={i} selected={Country == list.country ? true : false} value={list.country}>{list.country}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="px-form-group">
                                                <label>City <span className="px-req">*</span></label>
                                                <select className="px-select" value={City} onChange={(e) => handleCityChange(e.target.value)}>
                                                    <option value="">-- Please Select --</option>
                                                    {Citylist.map((list, i) => {
                                                        return (
                                                            <option key={i} selected={list.value == City ? true : false} value={list.value}>{list.label}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="px-form-group">
                                            <label>Address <span className="px-req">*</span></label>
                                            <textarea value={Address} className="px-input" rows={4} onChange={(e) => setAddress(e.target.value)} placeholder="Customer address" ></textarea>
                                        </div>
                                        {Subloading == false ?
                                            <button className="px-btn px-btn--primary" onClick={() => handleSubmit()}>Submit</button>
                                            :
                                            <button className="px-btn px-btn--primary" disabled><Loader2 size={15} className="px-spin" /> Submitting…</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Footer />
            </main>
        </>
    )
}
export default WarehouseEdit;
